export default __webpack_public_path__ + "media/color/bco-6f72ffba.svg";